import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionNotification from './ActionNotification';
import ApprovedLists from './ApprovedLists';
import Rules from './Rules';

interface DlpFilterProps {
  applyBoundShow: boolean;
  scanTargetShow: boolean;
  complianceRuleNoteShow?: boolean;
  advancedOptionsShow?: boolean;
  fileAdvancedOptionsShow?: boolean;
  mipShow?: boolean;
  advancedSettingsShowSalesforce?: boolean;
  showHeaderScan?: boolean;
  showApprovedSenders?: boolean;
}

const DlpFilter = ({
  applyBoundShow,
  scanTargetShow,
  complianceRuleNoteShow = false,
  advancedOptionsShow = false,
  fileAdvancedOptionsShow = false,
  mipShow = false,
  advancedSettingsShowSalesforce = false,
  showHeaderScan = false,
  showApprovedSenders = false,
}: DlpFilterProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          {showApprovedSenders && <Tab>{t('policy.approvedLists')}</Tab>}
          <Tab>{t('policy.label.notification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <Rules
              applyBoundShow={applyBoundShow}
              scanTargetShow={scanTargetShow}
              complianceRuleNoteShow={complianceRuleNoteShow}
              advancedOptionsShow={advancedOptionsShow}
              fileAdvancedOptionsShow={fileAdvancedOptionsShow}
              mipShow={mipShow}
              advancedSettingsShowSalesforce={advancedSettingsShowSalesforce}
              showHeaderScan={showHeaderScan}
            />
          </TabPanel>
          {showApprovedSenders && (
            <TabPanel>
              <ApprovedLists />
            </TabPanel>
          )}
          <TabPanel>
            <ActionNotification />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default React.memo(DlpFilter);

// Re-export components that might be used elsewhere
export { default as Rules } from './Rules';
export { default as ActionNotification } from './ActionNotification';
export { default as ApprovedLists } from './ApprovedLists';
export { default as ComplianceRules } from './ComplianceRules';
